var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 294.32 386.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.57,226.29,86,266.1H38.7a7.5,7.5,0,0,0-7.5,7.5v105a7.5,7.5,0,0,0,7.5,7.5h217a7.5,7.5,0,0,0,7.5-7.5v-105a7.5,7.5,0,0,0-7.5-7.5H208.29l-9.53-39.68C163.11,237.69,129.29,237,95.57,226.29ZM94.2,349.1v-45h106v45Z",
    fill: "#2287d5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M294.3,108.27c-.7-17.33-11.31-38.6-31-58.32C232,18.67,188.59,0,147.15,0,67.34,0,0,66.5,0,108.27c0,17.35,11.31,38.6,31,58.33,13.12,13.12,60.41,52.25,116.66,50C248.2,212.35,295.45,136.35,294.3,108.27ZM78.71,99H29.77c4.25-11,15-25.75,31.84-39.4C76.33,47.71,107,27.69,147.15,27.69c34.25,0,70.34,15.64,96.54,41.84C254.59,80.44,261.35,91,264.5,99H215.59V117.5h49c-4.25,10.95-15,25.75-31.85,39.4-14.72,11.93-45.42,31.95-85.54,31.95-34.25,0-70.34-15.64-96.53-41.84C39.71,136.1,33,125.57,29.8,117.5H78.71Z",
    fill: "#2287d5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.72,140.69V117.5h23.2v23.19c0,12,18.47,11.95,18.46,0V117.5h23.21v23.19c.86,13.66,18.45,10.14,18.46,0V78.19c-1.1-11.84-17.1-12.34-18.46,0V99H156.38V78.19c-.43-11.59-18.46-13.08-18.46,0V99H114.71V78.19c0-12.48-18.45-11-18.46,0v62.5C96.25,151.41,113.7,153.85,114.72,140.69Z",
    fill: "#2287d5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.6cb1eeda0a0cf3087cbebe828d9f4250.svg";
export { ForwardRef as ReactComponent };